import { render, staticRenderFns } from "./TodoFooter.vue?vue&type=template&id=47cb921d&scoped=true&"
import script from "./TodoFooter.vue?vue&type=script&lang=js&"
export * from "./TodoFooter.vue?vue&type=script&lang=js&"
import style0 from "./TodoFooter.vue?vue&type=style&index=0&id=47cb921d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb921d",
  null
  
)

export default component.exports